export default {
  ourteamUIState: (state) => state.ourteamUIState
}